<div class="modal-form" *ngIf="showframe">
  <div class="form-modal container">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-8">
        <div *ngIf="newFrame_idMedia==1" style="width: 100%; height: 400px">
          <vg-player>
            <video [vgMedia]="media" #media id="singleVideo" preload="auto" controls>
              <source [src]="url">
            </video>
          </vg-player>
        </div>
        <div *ngIf="newFrame_idMedia==2" style="width: 100%; height: 400px; text-align: center">
          <ngx-spinner *ngIf="loadingImg" bdOpacity=0.9 bdColor="#eee" size="medium" color="#e7403f"
                       type="line-scale"></ngx-spinner>
          <img [src]="url" onError="this.src='';" [hidden]="loadingImg"
               (load)="loadingImg=false"
               style="width: 100%; max-height: 100%; vertical-align: middle;">
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-4">
        <h4 style="text-align: left">Informacion frame</h4>
        <div class="form-group row">
          <label for="nombre" class="col-sm-2 col-form-label">Nombre</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="nombre" placeholder="Publicidad2"
                   [(ngModel)]="newFrame_nombre">
          </div>
        </div>

        <div class="form-group row" *ngIf="!frame.programacion && frame.idTipo !== 8">
          <label for="tipo" class="col-sm-2 col-form-label">Tipo</label>
          <div class="col-sm-10" ngbDropdown>
            <button class="btn" id="dropdownBasic1" ngbDropdownToggle id="tipo" style="width: 100%; text-align: left;">
              {{newFrame_idTipo ? newFrame_idTipo.type_title: 'SELECCIONAR TIPO'}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="width: 300px">
          <span *ngFor="let tipo of tipos">
            <button class="dropdown-item" (click)="selectTipo(tipo)" *ngIf="!tipo.hide"
                    [disabled]="!tipo.active" [ngStyle]="{'cursor':tipo.active? 'pointer':'default'}"
            >{{tipo.descripcion}}
          </button>
          </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="duracion" class="col-sm-2 col-form-label">Duracion</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="duracion" placeholder="segundos"
                   [(ngModel)]="newFrame_segundos"
                   [disabled]="frame.idMedia==1">
          </div>
        </div>
        <div style="text-align: left" *ngIf="frame && frame.programacion">
          <h4> Horario de transmisión</h4>
          <p></p>
          <!-- contratos-congelados T7: franja time inputs gated on
               features.franjasHorarias (disabled only when explicitly false). -->
          <div class="form-group row">
            <div class="col" style="width: 50%">
              <label for="fecha-desde">Fecha inicio</label>
              <input class="form-control" type="date" [value]="desde_dia | date:'yyyy-MM-dd'"
                     (input)="desde_dia = $event.target.valueAsDate" id="fecha-desde">
            </div>
            <div class="col" style="width: 50%">
              <label for="hora-desde">Hora Inicio</label>
              <input class="form-control" type="time" placeholder="Desde Hora" [(ngModel)]="desde_hora" id="hora-desde"
                     [disabled]="!(franjasAllowed$ | async)">

            </div>
          </div>
          <div class=" form-group row">
            <div class="col" style="width: 50%">
              <label for="fecha-hasta">Fecha Fin</label>
              <input class="form-control" type="date" [value]="hasta_dia | date:'yyyy-MM-dd'"
                     (input)="hasta_dia = $event.target.valueAsDate" id="fecha-hasta">
            </div>
            <div class="col" style="width: 50%">
              <label for="hora-hasta">Hora Fin</label>
              <input class="form-control" type="time" placeholder="Hasta Hora" [(ngModel)]="hasta_hora" id="hora-hasta"
                     [disabled]="!(franjasAllowed$ | async)">
            </div>
          </div>
          <div class="form-group row">
            <div class="col">
              <label>Días de la semana</label>
              <div class="dias-semana">
                <button type="button" class="btn btn-dia" *ngFor="let dia of diasSemana"
                        [title]="dia.nombre"
                        [ngClass]="{'dia-selected': diasSelected.indexOf(dia.id) >= 0}"
                        (click)="toggleDia(dia)">{{dia.inicial}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" style="text-align: center">
          <button type="button" (click)="createFrame()" style="background-color:#e7403f; margin-top: 10px;  margin:10px"
                  class="btn btn-danger btn-lg">Guardar Cambios
          </button>
          <button type="button" (click)="close()" style=" margin:10px"
                  class="btn btn-lg">Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/frame-view/frame-view.component.html